import React, {Component} from 'react';
import PropTypes from 'prop-types';

import KeyboardSelectionListener from './KeyboardSelectionListener';

/*
	This component is a basic wrapper component to make buttons, etc. keyboard focusable and selectable.
*/

export default class Focusable extends Component {
	render() {
		const {has_focus, focus_ref, on_select, children} = this.props;
		return <div
			style={{outline: has_focus ? '6px solid orange' : 'none'}}
			ref={focus_ref}
		>
			{has_focus && on_select ? <KeyboardSelectionListener on_select={on_select} /> : null}
			{children}
		</div>
	}
}
Focusable.propTypes = {
	has_focus: PropTypes.bool.isRequired,
	focus_ref: PropTypes.func.isRequired,
	on_select: PropTypes.func,
};
Focusable.defaultProps = {
	on_select: null,
};






// WEBPACK FOOTER //
// ./src/Focusable.js